<template>
    <div class="top-main">
        <div class="top-main__mobile">
            <div class="top-main__mobile_hamburger mr-2" v-on:click="clickMobileMenu">
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="top-main__mobile_logo">
                <img width="140" src="/images/logo.png" alt="PPC Shield" title="PPC Shield">
            </div>
        </div>
        <div class="top-main__right">
            <notifications group="foo" />
            <a class="top-main__support" target="_blank" href="https://www.ppcshield.io/support/">
                <inline-svg src="/images/question.svg" class="top-main__question-icon" aria-label="Questions"></inline-svg>
            </a>
            <div class="top-main__notification">
                <div class="top-main__notification__icon">
                    <inline-svg src="/images/bell.svg" aria-label="Settings"></inline-svg>
                    <div v-if="messages.length > 0" class="top-main__notification__icon__count">
                        {{messages.length}}
                    </div>
                </div>
                <div v-if="messages.length > 0" class="notification-box">
                    <ul class="message-box">
                        <li v-for="message in messages" class="message-box__message">
                            <div>
                                <div>{{message.message}}</div>
                                <div class="message-box__message__date">{{message.created_at}}</div>
                            </div>
                            <div v-on:click="closeMessage(message.id)" class="message-box__message__close-icon">
                                <inline-svg src="/images/close.svg"  aria-label="close"></inline-svg>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="top-main__current-user">
                <div class="dropdown">
                    <div class="top-main__current-user__role">
                        <div class="d-flex flex-row align-items-center">
                            <div class="top-main__current-user__role_user-email">
                                <div class="top-main__current-user__role__role">
                                    {{ user }}
                                </div>
                                <div class="top-main__current-user__role__name">
                                    {{ email }}
                                </div>
                            </div>
                            <div class="top-main__current-user__logo">
                                <template v-if="avatar">
                                    <img :src="avatar" aria-label="My image" />
                                </template>
                                <template v-else>
                                    <div class="letter-logo">
                                        <template v-if="user">{{user[0]}}</template>
                                        <template v-else><inline-svg style="fill: #495057; margin-top: -4px;" src="/images/account_circle_black_24dp.svg" aria-label="avatar"></inline-svg></template>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="dropdown-content">
                            <div id="user-email-info" class="dropdown-content-item no-hover">
                                <div class="user-info" :style="'max-width:'+screenWidth+'px;'">
                                    {{ user }}
                                </div>
                                <div class="user-info" :style="'max-width:'+screenWidth+'px;'">
                                    {{ email }}
                                </div>
                            </div>
                            <a href="/stripe/showCurrentSubscription" :class="'dropdown-content-item not-show-for-super-user' + (stripeInfo.stripe_id ? '' : ' disabled')">
                                <inline-svg class="icon" :src="`/images/arrows-circle.svg`" aria-label="Subscription"></inline-svg>
                                <span>
                                Subscription
                            </span>
                            </a>
                            <template v-if="!is_manager">
                                <a href="/accountSettings" class="dropdown-content-item">
                                    <inline-svg class="icon" :src="`/images/gear.svg`" aria-label="Account settings"></inline-svg>
                                    <span>
                                        Account settings
                                    </span>
                                </a>
                            </template>
                            <a href="/logout" class="dropdown-content-item">
                                <inline-svg class="icon" :src="`/images/logout.svg`" aria-label="logout"></inline-svg>
                                <span>
                                Sign out
                            </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <modal :height="'auto'" :width="'400px'" name="dialog-info-top">
            <div class="informative-modal flex flex-col">
                <div class="header">Billing information</div>

                <div class="body">
                    Your account does not have any billing information.
                </div>

                <div class="footer flex justify-end space-x-2">
                    <button class="btn btn-primary" @click="hideModal('dialog-info-top')">Close</button>
                </div>
            </div>
        </modal>

        <modal :height="'auto'" :width="'400px'" name="user-changed" :clickToClose="false">
            <div class="informative-modal flex flex-col">
                <div class="header">Session Expired</div>

                <div class="body">
                    Our system has detected that you have accessed another customer account from a new tab. It is not possible to view more than one account at same time. Please note that the displayed information will apply to the most recently viewed customer account.
                </div>

                <div class="footer flex justify-end space-x-2">
                    <button class="btn btn-primary" @click="reloadWindow()">Close</button>
                </div>
            </div>
        </modal>

    </div>
</template>
<script>
    export default {
        name: 'top',
        props: ['is_manager', 'user', 'email', 'avatar'],
        data: function () {
            return {
                messages: [],
                stripeInfo: {stripe_id: ''},
                loaded_user_id: null,
            }
        },
        computed:{
            screenWidth: () => {
                return window.innerWidth - 83;
            }
        },
        methods: {
            reloadWindow(){
                location.href = '/account';
            },
            clickMobileMenu(){
                const checkbox = $('#mobile-hamburger-check');
                checkbox.prop('checked', !checkbox.is(':checked'));
            },
            checkToOpenBillingPortal: function (event){
                if(!this.stripeInfo.stripe_id){
                    this.showModal('dialog-info-top');
                    event.preventDefault();
                }
                else {

                }
            },
            getStripeInfo: function (){
                axios.get('/stripe/stripe-info')
                    .then(info => {
                        this.stripeInfo = info.data;
                    });
            },
            closeMessage: function (id) {
                axios.post('/notification/changeStatus?id='+id+'&status=viewed')
                    .catch(err => console.log('err', err));
                this.messages = this.messages.filter(message => message.id !== id);
            },
            getNotifications: function () {
                axios.post('/notification/getNotifications')
                    .then(data => {
                        this.messages = data.data.map(notify => {
                            notify.created_at = this.dateTimeToNewFormat(notify.created_at);
                            return notify;
                        });
                    })
                    .catch(err => console.log('err', err));
            },
            dateTimeToNewFormat: function (dateTime) {
                if(!dateTime) return "";
                const date = dateTime.split('T')[0].split("-");
                const time = dateTime.split('T')[1].split('.')[0].split(':');
                return `${date[2]}/${date[1]}/${date[0]} ${time[0]}:${time[1]}`;
            },
            showModal(modal_name) {
                this.$modal.show(modal_name);
            },
            hideModal(modal_name) {
                this.$modal.hide(modal_name);
            },
            checkActiveUser(){
                if(localStorage.getItem('session_user_id') != this.loaded_user_id){
                    this.showModal('user-changed');
                }
            },
            getUserId(){
                axios.post('/notification/getCurrentUserId', null, {
                    headers: {
                        "accept": "application/json",
                        "content-type": "application/json"
                    }
                })
                    .then(data => {
                        this.loaded_user_id = data.data;
                        localStorage.setItem('session_user_id', this.loaded_user_id);
                    })
                    .catch(err => {
                        if(err.response.status === 401){
                            this.showModal('user-changed');
                        }
                    });
            },
        },
        mounted() {
            this.getUserId();
            setInterval(() => {
                this.checkActiveUser();
            }, 3000);

            this.getStripeInfo();
            this.getNotifications();
            setInterval(() => {this.getNotifications()}, 300000);
        }
    }
</script>
